import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../auxiliares/auxiliares.module';
import { ListarClientesComponent } from './listar-clientes/listar-clientes.component';
import { CrearEditarClienteComponent } from './crear-editar-cliente/crear-editar-cliente.component';
import { ClientesRoutingModule } from './clientes.routing.module';
import { ImportarComponent } from './crear-editar-cliente/importar/importar.component';
import { MdEditorComponent } from 'src/app/auxiliares/md-editor/md-editor.component';
import { TabWebLegacyComponent } from './crear-editar-cliente/tab-web-legacy/tab-web-legacy.component';
import { TabMonitoreoIntegracionesComponent } from './crear-editar-cliente/tab-monitoreo-integraciones/tab-monitoreo-integraciones.component';
import { TabSirenasComponent } from './crear-editar-cliente/tab-sirenas/tab-sirenas.component';
import { CategoriasClienteComponent } from './crear-editar-cliente/categorias-cliente/categorias-cliente.component';
import { TabAppNativaComponent } from './crear-editar-cliente/tab-app-nativa/tab-app-nativa.component';
import { CrearClienteWizardComponent } from './crear-cliente-wizard/crear-cliente-wizard.component';
import { ProvisionadorComponent } from './provisionador/provisionador.component';
import { CategoriaEditorSharedModule } from './categoria-editor/categoria-editor-shared.module';
import { ReemplazoCategoriaSharedModule } from '../categorias/reemplazo-categoria-dialog/reemplazo-categoria-shared.module';
import { ClienteFormComponent } from './cliente-form/cliente-form.component';
import { CategoriasSeccionComponent } from './cliente-form/categorias-seccion/categorias-seccion.component';
import { CategoriaDetalleComponent } from './cliente-form/categoria-detalle/categoria-detalle.component';
import { PantallasArmadoComponent } from './cliente-form/pantallas-armado/pantallas-armado.component';
import { AgregarCategoriaDialogComponent } from './cliente-form/agregar-categoria-dialog/agregar-categoria-dialog.component';
import { ServiciosTramitesSeccionComponent } from './cliente-form/servicios-tramites-seccion/servicios-tramites-seccion.component';
import { AgregarBotonServicioDialogComponent } from './cliente-form/agregar-boton-servicio-dialog/agregar-boton-servicio-dialog.component';
import { PlantillaManualEditorComponent } from './cliente-form/plantilla-manual/plantilla-manual-editor.component';
import { PlantillaManualPreviewComponent } from './cliente-form/plantilla-manual/plantilla-manual-preview.component';
import { IconoFuncionComponent } from './cliente-form/plantilla-manual/icono-funcion.component';

@NgModule({
  declarations: [
    ListarClientesComponent,
    CrearEditarClienteComponent,
    ImportarComponent,
    TabWebLegacyComponent,
    TabMonitoreoIntegracionesComponent,
    TabSirenasComponent,
    CategoriasClienteComponent,
    TabAppNativaComponent,
    CrearClienteWizardComponent,
    ProvisionadorComponent,
    // Form unificado: única pantalla de crear/editar cliente
    ClienteFormComponent,
    CategoriasSeccionComponent,
    CategoriaDetalleComponent,
    PantallasArmadoComponent,
    AgregarCategoriaDialogComponent,
    ServiciosTramitesSeccionComponent,
    AgregarBotonServicioDialogComponent,
    PlantillaManualEditorComponent,
    PlantillaManualPreviewComponent,
    IconoFuncionComponent,
  ],
  imports: [
    CommonModule,
    AuxiliaresModule,
    ClientesRoutingModule,
    MdEditorComponent,
    CategoriaEditorSharedModule,
    ReemplazoCategoriaSharedModule,
  ],
})
export class ClientesModule {}
